import React, { VFC } from 'react';
import styled from 'styled-components';
import { IIconProps } from './types';

const Wrapper = styled.div`
 display: block;
 margin: auto auto;
`;

const AddPhotoIcon: VFC<IIconProps> = ({ color, size }) => (
  <Wrapper>
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3,4V1h2v3h3v2H5v3H3V6H0V4H3z M6,10V7h3V4h7l1.83,2H21c1.1,0,2,0.9,2,2v12c0,1.1-0.9,2-2,2H5c-1.1,0-2-0.9-2-2V10H6z M13,19c2.76,0,5-2.24,5-5s-2.24-5-5-5s-5,2.24-5,5S10.24,19,13,19z M9.8,14c0,1.77,1.43,3.2,3.2,3.2s3.2-1.43,3.2-3.2 s-1.43-3.2-3.2-3.2S9.8,12.23,9.8,14z"
        fill={color}
      />
    </svg>
  </Wrapper>
);

export default AddPhotoIcon;
